import React, { useState } from 'react';

const SECTIONS = {
  annulation: {
    title: 'Annulation et remboursement',
    icon: '↩',
    content: [
      {
        heading: 'Politique d\'annulation',
        text: `Havenly applique une politique d'annulation claire et transparente, affichée sur chaque annonce avant la réservation.

Annulation gratuite : jusqu'à 14 jours avant l'arrivée — remboursement intégral sous 48h ouvrées.

Annulation modérée : entre 7 et 14 jours avant l'arrivée — remboursement de 50% du montant total.

Annulation tardive : moins de 7 jours avant l'arrivée — aucun remboursement.

Force majeure : remboursement intégral sur présentation d'un justificatif officiel (hospitalisation, décès, catastrophe naturelle).`,
      },
      {
        heading: 'Comment annuler une réservation ?',
        text: `1. Connectez-vous à votre compte Havenly
2. Rendez-vous dans "Mes réservations"
3. Sélectionnez la réservation concernée
4. Cliquez sur "Annuler cette réservation"
5. Confirmez votre annulation

Le remboursement est traité automatiquement selon la politique applicable. Vous recevrez un email de confirmation avec le montant remboursé.`,
      },
      {
        heading: 'Délais de remboursement',
        text: `Les remboursements sont effectués sur la carte bancaire utilisée lors de la réservation.

- Carte bancaire : 5 à 10 jours ouvrés selon votre banque
- Les remboursements sont initiés par Havenly dans les 48h suivant l'annulation

Si vous n'avez pas reçu votre remboursement après 10 jours ouvrés, contactez-nous à contact@havenly.fr`,
      },
      {
        heading: 'Annulation par l\'hôte',
        text: `Si l'hôte annule votre réservation :
- Vous êtes remboursé intégralement sous 48h
- Havenly vous aide à trouver un logement de remplacement si disponible

Les annulations répétées d'un hôte entraînent des sanctions pouvant aller jusqu'à la suppression de son compte.`,
      },
      {
        heading: 'Force majeure',
        text: `En cas de force majeure (pandémie, catastrophe naturelle, conflit armé), Havenly peut appliquer une politique d'annulation exceptionnelle permettant un remboursement intégral indépendamment des délais habituels.

Pour invoquer la force majeure, vous devez fournir un justificatif officiel dans les 24h suivant l'événement à contact@havenly.fr`,
      },
    ],
  },

  assurance: {
    title: 'Protection voyageur',
    icon: '🛡',
    content: [
      {
        heading: 'Protection incluse dans chaque réservation',
        text: `Chaque réservation sur Havenly inclut automatiquement une protection de base sans frais supplémentaires. Havenly n'est pas un assureur mais met en place des mécanismes de protection contractuels pour sécuriser votre séjour.`,
      },
      {
        heading: 'Ce qui est couvert',
        text: `Protection logement non conforme :
Si votre logement ne correspond pas à l'annonce (état réel différent des photos, équipements manquants, problème de sécurité), vous êtes protégé si vous signalez le problème dans les 24h suivant votre arrivée.

Protection paiement :
Votre paiement est sécurisé via Stripe. L'hôte est versé 24h après votre check-in — pas avant. En cas de litige signalé dans les 24h suivant l'arrivée, Havenly intervient sous 72h.

Protection annulation hôte :
Si l'hôte annule votre séjour, vous êtes remboursé intégralement sous 48h.`,
      },
      {
        heading: 'Dépôt de garantie',
        text: `Un dépôt de garantie peut être bloqué sur votre carte au check-in selon le type de logement. Son montant est indiqué avant la réservation (entre 30€ et 250€ selon le logement).

Ce dépôt n'est jamais prélevé sauf en cas de dommages prouvés causés au logement. Il est automatiquement libéré 48h après votre check-out si aucun litige n'est signalé par l'hôte.`,
      },
      {
        heading: 'Assurance voyage complémentaire',
        text: `La protection Havenly ne remplace pas une assurance voyage complète. Nous vous recommandons de souscrire une assurance voyage comprenant :

- Annulation pour raison médicale
- Rapatriement sanitaire
- Perte ou vol de bagages
- Responsabilité civile

Des partenaires assurance seront proposés prochainement directement sur la plateforme.`,
      },
      {
        heading: 'En cas de problème à l\'arrivée',
        text: `Si vous constatez un problème à l'arrivée :

1. Photographiez immédiatement les problèmes constatés
2. Contactez l'hôte via la messagerie Havenly
3. Si pas de réponse sous 2h, contactez le support Havenly
4. Signalez le problème via "Signaler un problème" dans votre espace voyageur

Vous avez 24h après l'arrivée pour signaler tout problème et bénéficier de la protection Havenly.`,
      },
    ],
  },

  signalement: {
    title: 'Signaler un problème',
    icon: '⚠',
    content: [
      {
        heading: 'Quand signaler un problème ?',
        text: `Vous pouvez signaler un problème dans les cas suivants :

- Le logement ne correspond pas à l'annonce (photos inexactes, équipements manquants)
- Le logement présente des problèmes de propreté ou d'hygiène
- Des équipements essentiels ne fonctionnent pas (eau chaude, chauffage, électricité)
- Vous vous sentez en insécurité
- L'hôte est inaccessible ou ne répond pas
- Vous avez subi des dommages pendant votre séjour`,
      },
      {
        heading: 'Comment signaler un problème ?',
        text: `Pendant votre séjour :
1. Connectez-vous à votre compte Havenly
2. Rendez-vous dans "Mes réservations"
3. Cliquez sur la réservation concernée
4. Sélectionnez "Signaler un problème"
5. Décrivez le problème avec des photos si possible
6. Soumettez votre signalement

Notre équipe vous contacte sous 2h en journée (9h-20h) et sous 4h la nuit.

Urgence : contact@havenly.fr`,
      },
      {
        heading: 'Délais de traitement',
        text: `- Accusé de réception : immédiat par email
- Premier contact de notre équipe : sous 2h (9h-20h) ou 4h (nuit)
- Investigation complète : sous 72h maximum
- Résolution ou proposition de solution : dans les 72h suivant la réception

Notre engagement : vous n'êtes jamais seul face à un problème.`,
      },
      {
        heading: 'Ce que nous pouvons faire',
        text: `Selon la nature et la gravité du problème :

- Médiation avec l'hôte pour résoudre le problème rapidement
- Remboursement partiel ou total si le logement ne correspond pas à l'annonce
- Aide au relogement d'urgence si le logement est inhabitable
- Signalement et sanction de l'hôte si nécessaire
- Activation de la Médiation du Tourisme et du Voyage (MTV) si nécessaire`,
      },
      {
        heading: 'Conseils pour un signalement efficace',
        text: `Pour que votre signalement soit traité rapidement :

- Signalez dans les 24h suivant la constatation du problème
- Joignez des photos horodatées
- Décrivez précisément le problème (lieu, nature, impact sur votre séjour)
- Conservez tous les échanges avec l'hôte via la messagerie Havenly
- Ne quittez pas le logement sans avoir contacté Havenly au préalable

Un signalement bien documenté permet une résolution beaucoup plus rapide.`,
      },
      {
        heading: 'Après le séjour',
        text: `Si vous souhaitez signaler un problème après votre départ (dégradation constatée lors du check-out, dépôt de garantie contesté) :

- Vous disposez de 48h après le check-out pour signaler
- Envoyez vos photos et documents à contact@havenly.fr
- Notre équipe traite les litiges post-séjour sous 5 jours ouvrés`,
      },
    ],
  },
};

export default function VoyageurPage({ onNavigate, voyageurPage }) {
  const [activePage, setActivePage] = useState(voyageurPage || 'annulation');
  const isMobile = window.innerWidth < 768;
  const section = SECTIONS[activePage] || SECTIONS['annulation'];

  const tabs = [
    { key: 'annulation', label: 'Annulation & remboursement' },
    { key: 'assurance', label: 'Assurance voyageur' },
    { key: 'signalement', label: 'Signaler un problème' },
  ];

  return (
    <div style={{ background: 'var(--surface)', minHeight: '100vh', paddingTop: 60 }}>

      {/* Header */}
      <div style={{ background: 'var(--white)', borderBottom: '1px solid var(--border)', padding: isMobile ? '1.5rem 1rem 0' : '2rem 2rem 0' }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <button onClick={() => onNavigate('home')} style={{ background: 'none', border: 'none', fontSize: 13, color: 'var(--ink-3)', cursor: 'pointer', padding: 0, marginBottom: 12 }}>
            ← Retour
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: 'var(--green-light)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--green-mid)" strokeWidth="1.5"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <h1 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 22 : 28, letterSpacing: '-0.5px' }}>
              Espace voyageurs
            </h1>
          </div>
          <div style={{ display: 'flex', gap: 0, overflowX: 'auto' }}>
            {tabs.map(tab => (
              <button key={tab.key} onClick={() => setActivePage(tab.key)} style={{
                padding: isMobile ? '10px 12px' : '12px 20px',
                border: 'none', background: 'transparent', cursor: 'pointer',
                fontFamily: 'var(--sans)', fontSize: isMobile ? 12 : 14,
                borderBottom: activePage === tab.key ? '2px solid var(--ink)' : '2px solid transparent',
                color: activePage === tab.key ? 'var(--ink)' : 'var(--ink-3)',
                fontWeight: activePage === tab.key ? 500 : 400,
                whiteSpace: 'nowrap',
              }}>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '1.5rem 1rem' : '2.5rem 2rem' }}>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 16, padding: isMobile ? '1.5rem' : '2.5rem' }}>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: isMobile ? 20 : 26, letterSpacing: '-0.5px', marginBottom: 32 }}>
            {section.title}
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
            {section.content.map((block, i) => (
              <div key={i}>
                <h3 style={{ fontSize: 15, fontWeight: 500, marginBottom: 10 }}>{block.heading}</h3>
                <div style={{ fontSize: 14, color: 'var(--ink-3)', lineHeight: 1.8, whiteSpace: 'pre-line' }}>
                  {block.text}
                </div>
              </div>
            ))}
          </div>

          {/* CTA contact */}
          <div style={{ marginTop: 40, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 12 }}>
            <div style={{ padding: '20px 24px', background: 'var(--green-light)', border: '1px solid var(--green)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--green-mid)', marginBottom: 6 }}>Besoin d'aide ?</div>
              <div style={{ fontSize: 13, color: 'var(--green-mid)', lineHeight: 1.6, marginBottom: 12 }}>
                Notre équipe répond sous 2h en journée.
              </div>
              <button onClick={() => onNavigate('voyageur', 'signalement')} style={{ fontSize: 13, fontWeight: 500, color: 'var(--green-mid)', background: 'none', border: '1px solid var(--green)', borderRadius: 20, padding: '6px 16px', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                Signaler un problème →
              </button>
            </div>
            <div style={{ padding: '20px 24px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 12 }}>
              <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 6 }}>Comment ça marche ?</div>
              <div style={{ fontSize: 13, color: 'var(--ink-3)', lineHeight: 1.6, marginBottom: 12 }}>
                Découvrez tout ce que Havenly fait pour vous.
              </div>
              <button onClick={() => onNavigate('howitworks')} style={{ fontSize: 13, fontWeight: 500, color: 'var(--ink-3)', background: 'none', border: '1px solid var(--border)', borderRadius: 20, padding: '6px 16px', cursor: 'pointer', fontFamily: 'var(--sans)' }}>
                Voir le guide →
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}